import { useState, useCallback } from 'react'
import { toast } from 'sonner'
import { api, DocumentType } from '../api/client'
import { Analytics } from '@/analytics/events'

interface ExportParams {
  fromDate?: string
  toDate?: string
  includeDocumentTypes?: DocumentType[]
}

export function useExport() {
  const [isExporting, setIsExporting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const exportData = useCallback(async (params: ExportParams) => {
    setIsExporting(true)
    setError(null)

    try {
      const { blob, filename } = await api.exportData(params)

      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
      Analytics.exportDownloaded(filename.endsWith('.csv') ? 'csv' : 'zip')
      toast.success('Export downloaded successfully')
    } catch (err: any) {
      const message = err?.message || 'Export failed'
      setError(message)
      toast.error(message)
    } finally {
      setIsExporting(false)
    }
  }, [])

  return { exportData, isExporting, error }
}
